// Generated by purs version 0.15.16
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString));
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJString);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonString);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var any = /* #__PURE__ */ Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var AccessNone = /* #__PURE__ */ (function () {
    function AccessNone() {

    };
    AccessNone.value = new AccessNone();
    return AccessNone;
})();
var AccessView = /* #__PURE__ */ (function () {
    function AccessView() {

    };
    AccessView.value = new AccessView();
    return AccessView;
})();
var AccessUpdate = /* #__PURE__ */ (function () {
    function AccessUpdate() {

    };
    AccessUpdate.value = new AccessUpdate();
    return AccessUpdate;
})();
var showFieldAccessLevel = {
    show: function (v) {
        if (v instanceof AccessNone) {
            return "NONE";
        };
        if (v instanceof AccessView) {
            return "VIEW";
        };
        if (v instanceof AccessUpdate) {
            return "UPDATE";
        };
        throw new Error("Failed pattern match at Widgets.Form.Access (line 21, column 1 - line 24, column 33): " + [ v.constructor.name ]);
    }
};
var isPrefix = function (prefix) {
    return function (full) {
        return eq(prefix)(Data_Array.take(Data_Array.length(prefix))(full));
    };
};
var isIndexPart = function (part) {
    return Data_Maybe.isJust(Data_Int.fromString(part));
};
var toPathParts = /* #__PURE__ */ (function () {
    var $50 = Data_Array.filter(function (part) {
        return part !== "" && !isIndexPart(part);
    });
    var $51 = Data_String_Common.split(".");
    return function ($52) {
        return $50($51($52));
    };
})();
var resolveFieldAccess = function (access) {
    return function (path) {
        var pathParts = toPathParts(path);
        var matchDepth = function (v) {
            var fieldParts = toPathParts(v.field);
            var $31 = isPrefix(fieldParts)(pathParts);
            if ($31) {
                return new Data_Maybe.Just(Data_Array.length(fieldParts));
            };
            return Data_Maybe.Nothing.value;
        };
        var pickBest = function (current) {
            return function (entry) {
                var v = matchDepth(entry);
                if (v instanceof Data_Maybe.Nothing) {
                    return current;
                };
                if (v instanceof Data_Maybe.Just) {
                    if (current instanceof Data_Maybe.Nothing) {
                        return new Data_Maybe.Just({
                            depth: v.value0,
                            access: entry.access
                        });
                    };
                    if (current instanceof Data_Maybe.Just && v.value0 >= current.value0.depth) {
                        return new Data_Maybe.Just({
                            depth: v.value0,
                            access: entry.access
                        });
                    };
                    if (current instanceof Data_Maybe.Just) {
                        return new Data_Maybe.Just(current.value0);
                    };
                    throw new Error("Failed pattern match at Widgets.Form.Access (line 78, column 23 - line 81, column 35): " + [ current.constructor.name ]);
                };
                throw new Error("Failed pattern match at Widgets.Form.Access (line 76, column 30 - line 81, column 35): " + [ v.constructor.name ]);
            };
        };
        var best = foldl(pickBest)(Data_Maybe.Nothing.value)(access.fields);
        return Data_Maybe.fromMaybe(access["default"])(map(function (v) {
            return v.access;
        })(best));
    };
};
var fullFormAccess = /* #__PURE__ */ (function () {
    return {
        "default": AccessUpdate.value,
        fields: [  ]
    };
})();
var eqFieldAccessLevel = {
    eq: function (x) {
        return function (y) {
            if (x instanceof AccessNone && y instanceof AccessNone) {
                return true;
            };
            if (x instanceof AccessView && y instanceof AccessView) {
                return true;
            };
            if (x instanceof AccessUpdate && y instanceof AccessUpdate) {
                return true;
            };
            return false;
        };
    }
};
var ordFieldAccessLevel = {
    compare: function (x) {
        return function (y) {
            if (x instanceof AccessNone && y instanceof AccessNone) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof AccessNone) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof AccessNone) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof AccessView && y instanceof AccessView) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof AccessView) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof AccessView) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof AccessUpdate && y instanceof AccessUpdate) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Widgets.Form.Access (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqFieldAccessLevel;
    }
};
var encodeFieldAccessLevel = {
    encodeJson: function (v) {
        if (v instanceof AccessNone) {
            return encodeJson("NONE");
        };
        if (v instanceof AccessView) {
            return encodeJson("VIEW");
        };
        if (v instanceof AccessUpdate) {
            return encodeJson("UPDATE");
        };
        throw new Error("Failed pattern match at Widgets.Form.Access (line 35, column 1 - line 38, column 50): " + [ v.constructor.name ]);
    }
};
var decodeFieldAccessLevel = {
    decodeJson: function (json) {
        return bind(decodeJson(json))(function (v) {
            if (v === "NONE") {
                return pure(AccessNone.value);
            };
            if (v === "VIEW") {
                return pure(AccessView.value);
            };
            if (v === "UPDATE") {
                return pure(AccessUpdate.value);
            };
            return new Data_Either.Left(new Data_Argonaut_Decode_Error.UnexpectedValue(json));
        });
    }
};
var canView = function (v) {
    if (v instanceof AccessNone) {
        return false;
    };
    return true;
};
var hasVisibleDescendant = function (access) {
    return function (path) {
        var pathParts = toPathParts(path);
        var isVisibleDescendant = function (v) {
            var fieldParts = toPathParts(v.field);
            return Data_Array.length(fieldParts) > Data_Array.length(pathParts) && (isPrefix(pathParts)(fieldParts) && canView(v.access));
        };
        return any(isVisibleDescendant)(access.fields);
    };
};
var canUpdate = function (v) {
    if (v instanceof AccessUpdate) {
        return true;
    };
    return false;
};
export {
    AccessNone,
    AccessView,
    AccessUpdate,
    fullFormAccess,
    canView,
    canUpdate,
    resolveFieldAccess,
    hasVisibleDescendant,
    toPathParts,
    isIndexPart,
    isPrefix,
    eqFieldAccessLevel,
    ordFieldAccessLevel,
    showFieldAccessLevel,
    decodeFieldAccessLevel,
    encodeFieldAccessLevel
};
//# sourceMappingURL=index.js.map
